import { DEFAULT_PAGE, OrderStatus } from "@app/constants";
import { CreateOrderRequest, Image, Order, OrderFilter, OrderResponse, OrderSummary } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _OrderService {
  public getOrders(
    page = DEFAULT_PAGE,
    imageName?: string,
    passRdp?: string,
    remoteExtIp?: string,
    status?: OrderStatus,
    filter: OrderFilter = {},
    /** gọi nền (tự cập nhật): không hiện loader / toast */
    silent = false
  ) {
    return HttpService.get<OrderResponse>("/orders", {
      silent,
      queryParams: {
        page,
        status,
        imageName,
        passRdp,
        remote_ext_ip: remoteExtIp,
        ...filter,
      },
    });
  }

  /** Số đơn và tổng chi của user cho trang Quản lý đơn hàng */
  public getOrderSummary(type: "pc" | "cloud" | "vps") {
    return HttpService.get<OrderSummary>("/orders/summary", {
      queryParams: { type },
    });
  }

  public createOrder(createOrderRequest: CreateOrderRequest) {
    return HttpService.post<Image>("/orders", {
      body: { ...createOrderRequest },
    });
  }

  public getRDPFile(imageId: string) {
    return HttpService.requestDownload(`/orders/file/${imageId}`);
  }

  public getOrderByImageId(imageId: string) {
    return HttpService.get<Order>(`/orders/image/${imageId}`);
  }

  public extendOrder(createOrderRequest: CreateOrderRequest) {
    return HttpService.patch<Order>("/orders/extend", {
      body: { ...createOrderRequest },
    });
  }

  public reset(ipAddress: string) {
    return HttpService.post<{ message: string }>("/tool/reset", {
      body: {
        id: ipAddress,
      },
    });
  }
}

const OrderService = new _OrderService();

export default OrderService;
